import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { $Elements, Animations, BrowserEvents, Classes } from '../global/constants';

gsap.registerPlugin(ScrollTrigger);

// ---------- Init Scroll Animation ----------

export const initScrollAnimations = () => {

	// ---------- Animated Section ----------

	$('.animated-section:not(.transition-clone)').each(function() {

		Animations.global.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					once: true,
					start: 'top 80%',
					toggleClass: Classes.active,
				}
			});
		});
	});

	// ---------- Content Sections ----------

	$('.parallax-section:not(.fixed-parallax-section):not(.transition-clone)').each(function() {

		Animations.mobile.min.push(() => {

			const image = this.querySelector(':scope .section-image');
			const speed = 25;

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
					},
				});

				timeline.fromTo(image, { yPercent: -speed }, { yPercent: speed, ease: 'none' });
			}
		});
	});

	// ---------- Affix ----------

	$('.single-product-section').each(function() {

		Animations.mobile.min.push(() => {

			const pinned = this.querySelectorAll(':scope .packshot, :scope .summary');

			if(pinned) {

				pinned.forEach(pin => {

					const timeline = gsap.timeline({
						scrollTrigger: {
							trigger: this,
							start: 0,
							end: 'bottom bottom',
							pin: pin,
						},
					});
				});
			}
		});

	});
};

$Elements.document.on(BrowserEvents.page.enter, () => initScrollAnimations());
